<template>
  <div class="address-block">
    <h2>Address</h2>
    <div v-show="!edit">
      <div>
        <p>{{ profile.addr1 }}</p>
      </div>
      <div>
        <p>{{ profile.addr2 }}</p>
      </div>
      <div>
        <p>{{ profile.addr3 }}</p>
      </div>
      <div>
        <p>{{ profile.postcode }}</p>
      </div>
      <div class="address-block-edit-btn">
        <button class="address-block-btn" @click="onClickEditToggle">
          <span>Edit</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
        </button>
      </div>
    </div>

    <div v-show="edit">
      <b-form class="address-form" @submit.stop.prevent="onSubmit">
        <b-row>
          <b-col>
            <b-form-input
              id="input-addr1"
              v-model.trim="$v.form.addr1.$model"
              type="text"
              class="mb-2"
              :state="validateState('addr1')"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              id="input-addr2"
              v-model="form.addr2"
              type="text"
              class="mb-2"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              id="input-addr3"
              v-model="form.addr3"
              type="text"
              class="mb-2"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input
              id="input-postcode"
              v-model.trim="$v.form.postcode.$model"
              type="text"
              :state="validateState('postcode')"
            />
          </b-col>
        </b-row>
        <b-row>
          <div class="address-block-btn-container pr-1">
            <button
              class="address-block-btn address-btn-cancel"
              @click.prevent="onClickEditToggle"
            >
              <span>Cancel</span
              ><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
            </button>
            <button
              type="submit"
              class="ml-lg-3 address-block-btn address-btn-submit"
            >
              <span>Submit</span
              ><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
            </button>
          </div>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  props: {
    profile: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
      form: {
        addr1: this.profile.addr1,
        addr2: this.profile.addr2,
        addr3: this.profile.addr3,
        postcode: this.profile.postcode,
      },
    };
  },
  validations: {
    form: {
      addr1: {
        required,
      },
      postcode: {
        required,
      },
    },
  },
  methods: {
    onClickEditToggle() {
      this.edit = !this.edit;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    ...mapActions({
      updateAddress: "profile/updateProfileAddressAction",
    }),
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      await this.updateAddress(this.form);
      this.edit = false;
    },
  },
};
</script>

<style>
@import "./styles.scss";
</style>
